import { AppTrack } from "./AppTrack";
import { HandoverSection } from "./HandoverSection";
import { PaymentsSection } from "./PaymentsSection";
import { DocumentPage } from "./PublishSection";
import { SalesOverview, SalespagePage } from "./SalesSection";
import { StrategyPage } from "./StrategySection";
import type { DeliverySectionContentProps } from "./shared";

export function DeliverySectionContent(props: DeliverySectionContentProps) {
  if (props.surface === "sales") return <SalesOverview {...props} />;
  if (props.surface === "strategy") return <StrategyPage {...props} />;
  if (props.surface === "salespage") return <SalespagePage {...props} />;
  if (props.surface === "emails") return <DocumentPage {...props} kind="emails" />;
  if (props.surface === "webinar") return <DocumentPage {...props} kind="webinar" />;
  // F82: publication is phase 3 of the sales page step and the stripe step is
  // hidden; both historic deep links land on the sales page step.
  if (props.surface === "publish") return <SalespagePage {...props} />;
  if (props.surface === "stripe") return <SalespagePage {...props} />;
  if (props.surface === "payments") return <PaymentsSection {...props} />;
  if (props.surface === "handover") return <HandoverSection {...props} />;
  // The mobile app side track lives in its own module (sections/AppTrack),
  // which routes the three app steps to their own pages (F135).
  return <AppTrack {...props} surface={props.surface} />;
}
